// Control Keys Constants
export const NEXA_LEGAL_ACCEPTANCE_KEY = 'nexa_legal_acceptance';
